import React from 'react';
import axios from 'axios';
import cx from 'classnames';
import moment from 'moment';

import { Link } from 'gatsby';

import styles from './index.module.scss';

const SECONDS_PER_DAY = 24 * 60 * 60;

/* eslint-disable react/prop-types */

const renderPost = (locale, props) => {
  const { _id, title, image, dateCreated } = props;
  return (
    <Link
      key={_id}
      to={`/post/${_id}`}
      className={cx({
        [styles.post]: true,
        [styles.emptyImage]: !image,
      })}
    >
      <h3 className={styles.postTitle}>
        {title}
        <div className={styles.date}>
          <div className={styles.month}>{moment.unix(dateCreated).format('MMM')}</div>
          <div className={styles.day}>{moment.unix(dateCreated).format('D')}</div>
        </div>
      </h3>
      {image ? <img src={image.url} alt={title} className={styles.image} /> : <div className={styles.image} />}
    </Link>
  );
};

const renderEvent = (locale, props) => {
  const { _id, title, dateStart } = props;
  return (
    <div key={_id} className={styles.event}>
      <div className={styles.label}>{locale === 'en' ? `Event` : `活動`}</div>
      <div className={styles.date}>
        <div className={styles.month}>{moment.unix(dateStart).format('MMM')}</div>
        <div className={styles.day}>{moment.unix(dateStart).format('D')}</div>
      </div>
      <div className={styles.eventTitle}>{title}</div>
    </div>
  );
};

export default class extends React.Component {
  static defaultProps = {
    locale: 'en',
  };

  state = {
    posts: [],
    events: [],
  };

  async componentDidMount() {
    const getPosts = axios({
      method: 'get',
      url: `/api/v1/posts`,
      params: {
        limit: 2,
      },
      headers: {
        'accept-language': `${this.props.locale}`,
      },
    });
    const getEvents = axios({
      method: 'get',
      url: `/api/v1/events?sort=dateStart`,
      params: {
        from: moment().unix() - SECONDS_PER_DAY,
        to: moment().unix() + SECONDS_PER_DAY * 30,
      },
      headers: {
        'accept-language': `${this.props.locale}`,
      },
    });
    // const getTweet = axios({
    //   method: 'get',
    //   url: `/api/v1/latest-tweet`,
    // });

    const [posts, events] = await Promise.all([getPosts, getEvents]);

    this.setState({
      posts: posts.data.data || [],
      events: events.data.data.slice(0, 3) || [],
    });
  }

  render() {
    const { locale } = this.props;
    const { posts, events } = this.state;

    return (
      <div className={styles.root}>
        <div className={styles.content}>
          <header>
            <h2 className={styles.title}>{locale === 'en' ? `What's New?` : `最新動態`}</h2>
            <p className={styles.tagline}>
              {locale === 'en' ? `Find out what's happening at Kingston` : '了解京斯敦的最新資訊及活動'}
            </p>
          </header>
          <div className={styles.items}>
            {posts.map(renderPost.bind(null, locale))}
            {events.map(renderEvent.bind(null, locale))}
          </div>
        </div>
      </div>
    );
  }
}
